module.exports = require('./helpers/bundle-url').getBundleURL('IQ6Sv') + "logo.c5857b8b.svg";